import { AGENT_VALIDATION_SUBMITTED } from './constants';
import { CFAuthPostRef } from "auth";
import { locations } from '../../common/redux/action_locations';

export function agentInfoVerificationSubmitted(value) {
  return {
    type: AGENT_VALIDATION_SUBMITTED,
    agentInfoVerificationSubmitted: value,
    showAgentVerificationForm: false,
    lockedOutShowAgentVerificationForm: false
  };
}

function receivedPostAgentVerificationInfo(data) {
  return async (dispatch) => {
    dispatch(agentInfoVerificationSubmitted(true))
  }
}

function postAgentVerificationInfo(data) {
  const body = {
    agentId: data.userID,
    phoneNumber: data.inputValues.phoneInput,
    email: data.inputValues.emailInput,
    address: {
      country: data.inputValues.countryInput,
      streetAddress: data.inputValues.addressInput,
      streetAddress2: data.inputValues.aptInput ? data.inputValues.aptInput : '',
      city: data.inputValues.cityInput,
      state: data.inputValues.stateInput,
      zipCode: data.inputValues.zipcodeInput ? data.inputValues.zipcodeInput : ''
    }
  }

  return CFAuthPostRef({
    url: process.env.REACT_APP_AP_API_URL+'/AgentVerification',
    body,
    originURL: process.env.PUBLIC_URL,
    loaderName: ''
  })
}

export function postAgentVerificationInfoAction(filters){
  return {
    type: 'POST_REQUEST_TIMEOFF',
    data: { locations, filters },
    locations: locations,
    fetchCall: postAgentVerificationInfo,
    receivedAction: receivedPostAgentVerificationInfo
  }
}
  
export function reducer(state, { type, agentInfoVerificationSubmitted, showAgentVerificationForm, lockedOutShowAgentVerificationForm }) {
  switch (type) {
    case AGENT_VALIDATION_SUBMITTED:
      return {
        ...state,
        agentInfoVerificationSubmitted,
        showAgentVerificationForm,
        lockedOutShowAgentVerificationForm
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/postAgentVerificationInfo.js